import { useQuery } from "@apollo/client";
import { IReasonForCancelResponse } from "./reason-for-cancel.interface";
import { REASON_FOR_CANCEL } from "./reason-for-cancel.query";

export const useReasonForCancel = () => {
  const { loading, data } = useQuery<{ getReasonsForCancel: IReasonForCancelResponse }>(REASON_FOR_CANCEL);

  return {
    loading,
    reasonForCancel: data?.getReasonsForCancel,
  };
};
